const CALENDLY_SCRIPT_URL = 'https://assets.calendly.com/assets/external/widget.js'
const CALENDLY_CSS_URL = 'https://assets.calendly.com/assets/external/widget.css'

export const CALENDLY_USER_MEETING_URLS = {
    de: 'https://calendly.com/alvdigital/alv-anwendergespraech',
    en: 'https://calendly.com/goran-pesic-alvdigital/user-meeting',
    ja: 'https://calendly.com/alvdigital/alv-anwendergespraech',
    ko: 'https://calendly.com/alvdigital/alv-anwendergespraech',
}

let widgetLoading = null

function loadCalendlyWidget() {
    if (window.Calendly) return Promise.resolve()
    if (widgetLoading) return widgetLoading

    widgetLoading = new Promise((resolve, reject) => {
        if (!document.querySelector(`link[href="${CALENDLY_CSS_URL}"]`)) {
            const link = document.createElement('link')
            link.rel = 'stylesheet'
            link.href = CALENDLY_CSS_URL
            document.head.appendChild(link)
        }

        const script = document.createElement('script')
        script.src = CALENDLY_SCRIPT_URL
        script.async = true
        script.onload = () => window.Calendly ? resolve() : reject(new Error('Calendly not available'))
        script.onerror = () => {
            script.remove()
            reject(new Error('Calendly script failed to load'))
        }
        document.head.appendChild(script)
    }).catch(error => {
        widgetLoading = null
        throw error
    })

    return widgetLoading
}

export async function openCalendlyPopup(urls, locale) {
    const url = urls[locale] || urls.de
    if (!url) return

    try {
        await loadCalendlyWidget()
        window.Calendly.initPopupWidget({ url })
    } catch (error) {
        window.open(url, '_blank', 'noopener,noreferrer')
    }
}
